<template>
    <log :data="data" />
</template>

<script>
import log from '../log'
import API from '@/service/api'
export default {
    components: {
        log
    },
    data () {
        return {
            data: [],
            logSubscribe: null // 日志websocket订阅
        }
    },
    created () {
        this.refresh()
    },
    methods: {
        refresh () {
            this.axios.get(this.urlFormat(API.GET_HOST_LOGS + '/' + this.$route.params.id, true)).then((res) => {
                this.data = res || []
                // 订阅websocket
                this.logSubscribe = this.$websocket('/topic/' + this.$route.params.id, (result) => {
                    this.data.push(result)
                })
            })
        }
    },
    beforeDestroy () {
        // 取消websocket订阅
        if (this.logSubscribe) {
            this.logSubscribe.unsubscribe()
        }
    }
}
</script>
